import React from 'react';
import withIcon from '../utilities/withIcon';

const IconPencilBox = () => {
  return (
    <g>
      <path d="m12.1787 8.1489a.75.75 0 0 0 -.75.75v5.3462h-9.8467v-9.8467h5.9629a.75.75 0 0 0 0-1.5h-6.7129a.75.75 0 0 0 -.75.75v11.3467a.75.75 0 0 0 .75.75h11.3467a.75.75 0 0 0 .75-.75v-6.0962a.75.75 0 0 0 -.75-.75z" />
      <path d="m15.6982 2.6489-2.1738-2.1743a.75.75 0 0 0 -1.0605 0l-1.64 1.64-.0015.001-.001.0015-4.8458 4.8458a.75.75 0 0 0 -.22.53v2.1746a.75.75 0 0 0 .75.75h2.1744a.7494.7494 0 0 0 .53-.22l4.8462-4.8462.001-.0005.0014-.0019 1.64-1.64a.75.75 0 0 0 -.0004-1.06zm-2.7041-.5835 1.1133 1.1138-.58.58-1.114-1.113zm-4.625 6.8521h-1.1132v-1.1138l4.097-4.097 1.1136 1.1133z" />
    </g>
  );
};

export default withIcon(IconPencilBox);
